import React, { useEffect, useState } from "react";
import { Table } from "flowbite-react";
import DateComponent from "../components/DateComponent";
import { Link } from "react-router-dom";
import { useEmployeeManagement } from "../context/EmployeeManagementContextHelper";
import { useWidget } from "../context/WidgetContextHelper";
import extractDate from "../utils/Helpers";

const EmployeeManagementPage = () => {
  const {
    userEmployees,
    getUserEmployees,
    companyProfile,
    getCompanyProfile,
    deleteEmployee,
  } = useEmployeeManagement();

  const {
    directDepositWidget,
    taxPaymentsWidget,
    getDirectDepositWidget,
    getTaxPaymentsWidget,
  } = useWidget();

  const [endOfYear, setEndOfYear] = useState("");

  useEffect(() => {
    (async () => {
      await getUserEmployees();
      await getCompanyProfile();
      await getDirectDepositWidget();
      await getTaxPaymentsWidget();
    })();
  }, []);

  useEffect(() => {
    if (companyProfile.plan_start_date) {
      const date = new Date(companyProfile.plan_start_date);
      const endOfYearDate = new Date(date.getFullYear(), 11, 31);
      const formattedDate =
        endOfYearDate.getFullYear() +
        "-" +
        String(endOfYearDate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(endOfYearDate.getDate()).padStart(2, "0");
      setEndOfYear(formattedDate);
    }
  }, [companyProfile.plan_start_date]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row justify-between w-full gap-4">
        <div className="w-4/6 h-full w-full">
          <div className="border border-gray-200 rounded-md p-4 flex flex-col justify-between shadow-md mb-2">
            <h2 className="text-gray-900 text-xl md:text-2xl lg:text-3xl xl:text-5xl font-bold mb-5">
              Employee Management Dashboard
            </h2>
            <div className="flex flex-row gap-4">
              {companyProfile.plan_start_date && (
                <DateComponent
                  title="Start"
                  dateString={companyProfile.plan_start_date}
                />
              )}
              {endOfYear && (
                <DateComponent title="End" dateString={endOfYear} />
              )}
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-4 w-full">
            <button className="border rounded-md p-4 flex flex-col w-full shadow-md">
              <h1 className="font-bold text-xl">Banking Info</h1>
              <p className="text-justify">
                {directDepositWidget && directDepositWidget.content}
              </p>
            </button>
            <button className="border rounded-md p-4 flex flex-col w-full shadow-md">
              <h1 className="font-bold text-xl">Tax Payments & Tax Filings</h1>
              <p className="text-justify">
                {taxPaymentsWidget && taxPaymentsWidget.content}
              </p>
            </button>
          </div>
        </div>
        <div className="md:w-2/6 border border-gray-200 rounded-md overflow-y-auto">
          <Table
            hoverable
            theme={{
              root: {
                base: "w-full text-left text-sm text-gray-500 dark:text-gray-400 h-full",
                wrapper: "relative h-full",
              },
            }}
          >
            <Table.Head>
              <Table.Cell className="font-bold text-gray-900 text-lg md:text-2xl ml-10">
                Totals
              </Table.Cell>
            </Table.Head>
            <Table.Body className="divide-y w-full">
              <Table.Row className={`dark:border-gray-700 dark:bg-gray-800`}>
                <Table.Cell>Annual Payroll</Table.Cell>
                <Table.Cell className="font-medium text-md text-[#0E0D0D]">
                  12,600
                </Table.Cell>
              </Table.Row>
              <Table.Row className={`dark:border-gray-700 dark:bg-gray-800`}>
                <Table.Cell>Employee Count</Table.Cell>
                <Table.Cell className="font-medium text-md text-[#0E0D0D]">
                  12,600
                </Table.Cell>
              </Table.Row>
              <Table.Row className={`dark:border-gray-700 dark:bg-gray-800`}>
                <Table.Cell>Plan Participant</Table.Cell>
                <Table.Cell className="font-medium text-md text-[#0E0D0D]">
                  12,600
                </Table.Cell>
              </Table.Row>
              <Table.Row className={`dark:border-gray-700 dark:bg-gray-800`}>
                <Table.Cell>Count</Table.Cell>
                <Table.Cell className="font-medium text-md text-[#0E0D0D]">
                  12,600
                </Table.Cell>
              </Table.Row>
              <Table.Row className={`dark:border-gray-700 dark:bg-gray-800`}>
                <Table.Cell>Shares</Table.Cell>
                <Table.Cell className="font-medium text-md text-[#0E0D0D]">
                  12,600
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </div>
      <div className="flex flex-col gap-4 border p-4 rounded-md mb-4 ">
        <div className="w-full flex flex-col md:flex-row justify-between">
          <h1 className="text-xl font-bold tracking-tight text-gray-900 py-2 block md:hidden">
            Employees
          </h1>
          <div className="flex flex-row justify-between w-full">
            <Link
              className="rounded-md bg-[#003464] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-[#c96b1a] flex flex-row justify-between items-center mr-4 hover:shadow-lg"
              to={"add-employee"}
            >
              <span className="pl-2 block">Add Employee</span>
            </Link>
            <h1 className="text-xl font-bold tracking-tight text-gray-900 py-2 hidden md:block">
              Employees
            </h1>
            <form className="w-2/4 md:w-1/5">
              <label
                htmlFor="default-search"
                className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
              >
                Search
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg
                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>
                <input
                  type="search"
                  id="default-search"
                  className="block w-full px-3 py-3 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-[#003464] focus:border-[#003464]"
                  placeholder="Search"
                  required
                />
              </div>
            </form>
          </div>
        </div>
        <div className="relative overflow-y-auto">
          <Table
            hoverable
            theme={{
              root: {
                base: "w-full text-left text-sm text-gray-500 dark:text-gray-400",
                shadow:
                  "absolute bg-white dark:bg-black w-full h-full top-0 left-0 rounded-lg -z-10",
                wrapper: "relative",
              },
            }}
          >
            <Table.Head>
              <Table.HeadCell className="whitespace-nowrap">
                Employee Name
              </Table.HeadCell>
              <Table.HeadCell>Email</Table.HeadCell>
              <Table.HeadCell>Phone</Table.HeadCell>
              <Table.HeadCell>Encrypted SSN</Table.HeadCell>
              <Table.HeadCell>Encrypted DOB</Table.HeadCell>
              <Table.HeadCell>Address</Table.HeadCell>
              <Table.HeadCell>City</Table.HeadCell>
              <Table.HeadCell>State</Table.HeadCell>
              <Table.HeadCell>Zip Code</Table.HeadCell>
              <Table.HeadCell>Vesting Schedule</Table.HeadCell>
              <Table.HeadCell>Hire Date</Table.HeadCell>
              <Table.HeadCell>Job Title</Table.HeadCell>
              <Table.HeadCell>Pay Rate</Table.HeadCell>
              <Table.HeadCell>Pay Period</Table.HeadCell>
              <Table.HeadCell>Annual Salary</Table.HeadCell>
              <Table.HeadCell>Employment Status</Table.HeadCell>
              <Table.HeadCell>Termination Date</Table.HeadCell>
              <Table.HeadCell>
                <span className="sr-only">Edit</span>
              </Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
              {userEmployees.map((userEmployee) => {
                return (
                  <Table.Row
                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                    key={userEmployee.id}
                  >
                    <Table.Cell className="whitespace-nowrap font-medium text-blue-600 hover:underline dark:text-white">
                      <Link
                        to={`/dashboard/employee-management/preview/${userEmployee.id}`}
                      >
                        {userEmployee.middle_name
                          ? userEmployee.first_name +
                            " " +
                            userEmployee.middle_name +
                            " " +
                            userEmployee.last_name
                          : userEmployee.first_name +
                            " " +
                            userEmployee.last_name}
                      </Link>
                    </Table.Cell>
                    <Table.Cell>{userEmployee.email}</Table.Cell>
                    <Table.Cell className="whitespace-nowrap">
                      {userEmployee.phone}
                    </Table.Cell>
                    <Table.Cell className="whitespace-nowrap">
                      {"***-**-" + userEmployee.encrypted_ssn.slice(-4)}
                    </Table.Cell>
                    <Table.Cell className="whitespace-nowrap">
                      {extractDate(userEmployee.encrypted_dob) + "/****"}
                    </Table.Cell>
                    <Table.Cell>{userEmployee.address}</Table.Cell>
                    <Table.Cell>{userEmployee.city}</Table.Cell>
                    <Table.Cell>{userEmployee.state}</Table.Cell>
                    <Table.Cell>{userEmployee.zip_code}</Table.Cell>
                    <Table.Cell>{userEmployee.vesting_schedule}</Table.Cell>
                    <Table.Cell className="whitespace-nowrap">
                      {userEmployee.hire_date}
                    </Table.Cell>
                    <Table.Cell>{userEmployee.job_title}</Table.Cell>
                    <Table.Cell>{userEmployee.pay_rate}</Table.Cell>
                    <Table.Cell>{userEmployee.pay_period}</Table.Cell>
                    <Table.Cell>{userEmployee.annual_salary}</Table.Cell>
                    <Table.Cell>{userEmployee.employment_status}</Table.Cell>
                    <Table.Cell className="whitespace-nowrap">
                      {userEmployee.termination_date}
                    </Table.Cell>
                    <Table.Cell>
                      <Link
                        className="font-medium text-blue-600 hover:underline dark:text-cyan-500 whitespace-nowrap"
                        to={`/dashboard/employee-management/edit-employee/${userEmployee.id}`}
                      >
                        Edit
                      </Link>
                      <span
                        className="font-medium text-red-600 ms-3 hover:underline dark:text-cyan-500 whitespace-nowrap hover:cursor-pointer"
                        onClick={() => {
                          deleteEmployee(userEmployee.id);
                        }}
                      >
                        Remove
                      </span>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default EmployeeManagementPage;
